import React, { memo, useContext, useEffect, useMemo, useState } from "react";
import "./ProductDetails.css";
import theme from "../../utils/theme";
import { useHistory, useParams } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Grid,
  Rating,
  Typography,
} from "@mui/material";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import HomeIcon from "@mui/icons-material/Home";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useBusinessQuery from "../../store/Bussiness/useBusinessQuery";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import noPic from "../../assets/no-pic.png";
import phone from "../../assets/phone.svg";
import thumbnail from "../../assets/thumbnail.png";
import categoryicon from "../../assets/categoryicon.png";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import web from "../../assets/web.svg";
import whatsapp from "../../assets/whatsapp.svg";
import Youtube from "../../assets/Youtube.svg";
import instagram from "../../assets/Instagram.svg";
import facebook from "../../assets/facebook.svg";
import ShareIcon from "@mui/icons-material/Share";
import google from "../../assets/google.svg";
import phonecall from "../../assets/phonecall.svg";
import HeroCarousel from "../../components/Carousel";
import google_review from "../../assets/google_review.svg";
import { saveRecentlyViewed } from "../myListing/bookmark/MyBookmarks";
import { variableContext } from "../../context/VariableContex";
import LayoutToggle from "../../components/LayoutToggle/LayoutToggle";
import "../../page-header-controls.css";

const ProductDetails = () => {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const history = useHistory();
  const { id } = useParams();
  const { layoutMode: appLayoutMode } = useContext(variableContext);
  const pdHeaderBg = appLayoutMode === "list" ? "#edf7ed" : "#edf7ed";
  const pdHeaderColor = appLayoutMode === "list" ? "#134013" : "#134013";
  const local = JSON.parse(localStorage.getItem("user"));

  const [value, setValue] = React.useState(0);
  const [ratingChange, setRatingChange] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [coverImages, setCoverImages] = useState([]);
  const [viewers, setViewers] = useState(null);
  const [callCounts, setCallCounts] = useState(null);
  const [layoutMode, setLayoutMode] = useState("fourCol");
  const [selectedCatalogueCategory, setSelectedCatalogueCategory] = useState("");

  // Reset all local state whenever the business id changes so no stale
  // data from a previously viewed business is ever displayed.
  useEffect(() => {
    setValue(0);
    setRatingChange(true);
    setOpen(false);
    setSelectedIndex(0);
    setCoverImages([]);
    setViewers(null);
    setCallCounts(null);
    setSelectedCatalogueCategory("");
  }, [id]);

  const { data: businessDetails, isSuccess: businessSuccess } =
    useBusinessQuery.Get_details(id);

  const { data: getRating, isSuccess: getSuccess } =
    useBusinessQuery.Get_rating(id);

  const { mutateAsync: updateRating, isSuccess: sucesssRating } =
    useBusinessQuery.Update_rating();

  const { data: bookmarkList } = useBusinessQuery.Get_bookmark_list();

  const { mutateAsync: addBookmark } = useBusinessQuery.Add_bookmark();

  const { mutateAsync: addViews } = useBusinessQuery.Add_views();

  const { mutateAsync: addCalls } = useBusinessQuery.Add_calls();

  const { data: callCountData } = useBusinessQuery.Get_call_count(id);

  const catalogueImages = businessDetails?.data?.catalogue_images?.filter((item) => Boolean(item.catalogue_image)) ?? [];

  // Duplicate images for seamless infinite CSS scroll loop
  const miniCarouselImages = catalogueImages.length > 0
    ? [...catalogueImages, ...catalogueImages]
    : [];

  const catalogueCategories = useMemo(() => {
    if (businessDetails?.data?.catalogue_image_categories?.length) {
      return businessDetails.data.catalogue_image_categories;
    }
    if (!catalogueImages.length) return [];
    const categories = [];
    const seen = new Set();
    catalogueImages.forEach((item) => {
      const category = item.image_category;
      if (category && !seen.has(category.id)) {
        seen.add(category.id);
        categories.push(category);
      }
    });
    return categories;
  }, [businessDetails, catalogueImages]);

  const filteredCatalogueImages = useMemo(() => {
    if (!selectedCatalogueCategory) return catalogueImages;
    return catalogueImages.filter((item) => {
      const itemCategoryId =
        item.image_category && typeof item.image_category === "object"
          ? item.image_category.id
          : item.image_category;
      return String(itemCategoryId) === String(selectedCatalogueCategory);
    });
  }, [catalogueImages, selectedCatalogueCategory]);

  const slide = filteredCatalogueImages.map((data) => ({
    src: data?.catalogue_image,
    key: data?.id,
    id: data?.id,
    width: "100%",
    height: "100%",
  }));

  const scrollTo = () =>
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });


  // state

  // fetch viewers
  useEffect(() => {
    handleViewers();
  }, [id]);

  const handleViewers = async () => {
    try {
      const response = await addViews({
        business_id: parseInt(id),
      });
      setViewers(response.data); // store response in state
    } catch (error) {
      console.error("Error adding viewers:", error);
    }
  };

  // log viewers only when it changes
  useEffect(() => {
    if (viewers) {
      console.log("Viewers API response:", viewers);
    }
  }, [viewers]);

  // initialize call count from GET API on page load
  useEffect(() => {
    if (callCountData) {
      setCallCounts(callCountData.data || callCountData);
    }
  }, [callCountData]);

  // log calls count only when it changes
  useEffect(() => {
    if (callCounts) {
      console.log("Calls Count API response:", callCounts);
    }
  }, [callCounts]);


  const handleAddFavourite = async (e, id) => {
    if (local?.id) {
      try {
        await addBookmark(id);
      } catch (error) { }
    } else {
      return;
    }
  };

  const handleRating = async () => {
    try {
      await updateRating({
        score: value,
        id,
      });
    } catch (error) { }
  };

  useEffect(() => {
    if (businessSuccess && businessDetails && businessDetails.data?.id === parseInt(id)) {
      setCoverImages(
        businessDetails.data.cover_images.map((item) => ({
          cover_image: item.cover_image,
        }))
      );
      // Auto-save to Recently Viewed
      saveRecentlyViewed({
        id: businessDetails.data.id,
        name: businessDetails.data.name,
        image: businessDetails.data.image,
        category_name: businessDetails.data.category_name,
        sub_category_name: businessDetails.data.sub_category_name,
        post_office: businessDetails.data.post_office,
        district_name: businessDetails.data.district_name,
      });
    }
  }, [businessSuccess, businessDetails, id]);

  // useEffect(() => {
  //   scrollTo();
  //   handleViews();
  // }, []);

  useEffect(() => {
    if (sucesssRating) {
      setRatingChange(false);
    }
  }, [sucesssRating]);

  useEffect(() => {
    if (getSuccess) {
      setValue(getRating?.data?.score);
      if (getRating?.data?.score) {
        setRatingChange(false);
      }
    }
  }, [getSuccess]);

  const handleCalls = async () => {
    try {
      const response = await addCalls({
        business_id: parseInt(id),
      });
      setCallCounts(response.data || response); // update call counts when icon is clicked
    } catch (error) {
      console.error("Error adding calls count:", error);
    }
  };

  const handleShare = async () => {
    try {
      await navigator.share({
        url: `https://backend.masterclick.in/api/v1/business/${id}/preview/`,
      });
    } catch (error) { }
  };


  // useEffect(() => {
  //   if (businessSuccess && businessDetails) {
  //     console.log("Business Details API response:", businessDetails);
  //   }
  // }, [businessSuccess, businessDetails]);

  useEffect(() => {
    if (getSuccess && getRating) {
      console.log("Rating API response:", getRating);
    }
  }, [getSuccess, getRating]);

  // useEffect(() => {
  //   if (bookmarkList) {
  //     console.log("Bookmark List API response:", bookmarkList);
  //   }
  // }, [bookmarkList]);





  return (
    <div className={appLayoutMode === "list" ? "pd-crystal-page" : "pd-dark-page"}>
      <div className="phc-bar">
        <div className="phc-inner">
          <div className="phc-row">
            <div className="phc-back" onClick={() => history.goBack()}>
              <ArrowBackIcon className="phc-back-icon" />
              <span className="phc-back-label">Back</span>
            </div>
            <button className="phc-home-btn" onClick={() => history.push("/")}>
              <HomeIcon className="phc-home-btn-icon" />
              <span className="phc-home-btn-label">Home</span>
            </button>
            <div className="phc-spacer" />
            <LayoutToggle size="sm" />
            <div className="phc-share-btn" onClick={handleShare}>
              <ShareIcon />
            </div>
          </div>
        </div>
      </div>

      <div className="product-details-root">
        <div className="pd-left-col">
          <div className="product-carousel-section">
            <Box sx={{ paddingTop: "0px" }}>
              <HeroCarousel
                data={businessDetails?.data?.cover_images}
                fallbackImage={businessDetails?.data?.image}
              />
            </Box>
          </div>
          {miniCarouselImages.length > 0 && (
            <div className="pd-desk-mini-carousel-wrap">
              <div className="pd-desk-mini-carousel-track">
                {miniCarouselImages.map((item, idx) => (
                  <div className="pd-desk-mini-thumb" key={`desk-${item.id}-${idx}`}>
                    <img src={item.catalogue_image} alt="" />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="product-details-main">
          <div className="product-info-section">
          <div className="product-content" style={{ padding: "20px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "5px",
              }}
            >
              <div>
                <h3 className="pd-customer-name" style={{ paddingBottom: 0, margin: 0, fontSize: "190%" }}>
                  {businessDetails && businessDetails?.data?.name}
                </h3>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: ".5rem",
                  }}
                >
                  <img src={categoryicon} className="category-icon-img" width="16px" height="16px" alt="" />
                  <p
                    style={{
                      padding: 0,
                      margin: 0,
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                  >
                    {businessDetails && businessDetails?.data?.sub_category}
                  </p>
                </div>
              </div>
              <div className="pd-action-group">
                {/* View count */}
                <div className="pd-action-btn pd-action-btn--view" style={{ position: "relative" }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5a7fa8" strokeWidth="2">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                  {viewers?.total_views > 1 && (
                    <span className="pd-action-badge">
                      {viewers?.total_views > 999
                        ? `${(viewers?.total_views / 1000).toFixed(1)}K`
                        : viewers?.total_views}
                    </span>
                  )}
                </div>
                {/* Favourite */}
                <div className="pd-action-btn pd-action-btn--fav">
                  <Checkbox
                    {...label}
                    checked={
                      bookmarkList?.data?.results?.some((value) => value.id === id)
                        ? true
                        : false
                    }
                    checkedIcon={<Favorite style={{ color: "#e53935", width: "16px", height: "16px" }} />}
                    icon={<FavoriteBorder style={{ color: "#a07070", width: "16px", height: "16px" }} />}
                    onChange={(e) => handleAddFavourite(e, id)}
                    sx={{ width: "36px", height: "36px", padding: 0 }}
                  />
                </div>
                {/* Share */}
                <div className="pd-action-btn pd-action-btn--share" onClick={handleShare}>
                  <ShareIcon style={{ width: "16px", height: "16px", color: "#5a7a5a" }} />
                </div>
              </div>
            </div>
            <hr />
            <div
              className="pd-location-row"
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                marginBottom: "6px",
              }}
            >
              <Typography style={{ fontSize: "12px", fontWeight: "500" }}>
                {businessDetails?.data?.post_office &&
                  businessDetails?.data?.post_office + ", "}
                {businessDetails?.data?.district_name &&
                  businessDetails?.data?.district_name + ", "}
                {businessDetails?.data?.state_name &&
                  businessDetails?.data?.state_name + ", "}
                {businessDetails?.data?.pin_code && businessDetails?.data?.pin_code}
              </Typography>
            </div>
            {businessDetails?.data?.mobile_number && (
              <div
                className="pd-call-row"
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                  marginBottom: "15px",
                }}
              >
                <CallIcon style={{ fontSize: "16px", color: appLayoutMode === "list" ? "#7dd3fc" : "rgba(33,130,177,1)", flexShrink: 0 }} />
                  <span style={{ color: appLayoutMode === "list" ? "rgba(185,218,255,0.70)" : "#555", marginRight: "3px" }}>Call:</span>
                  <a
                    href={`tel:+91-${businessDetails.data.mobile_number}`}
                    style={{ color: appLayoutMode === "list" ? "#7dd3fc" : "rgba(33,130,177,1)", textDecoration: "none", fontWeight: "600" }}
                  >
                    {businessDetails.data.mobile_number}
                  </a>
              </div>
            )}
            <div className="pd-about-us-section">
              <Typography
                className="about-us-heading-section"
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  marginTop: "17px",
                  marginBottom: "8px",
                }}
              >
                About Us
              </Typography>
              <div className="about-us-body-card">
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "23px",
                    wordBreak: "break-word !important",
                  }}
                >
                  {businessDetails && businessDetails?.data?.about_us}
                </Typography>
              </div>
            </div>
            <hr />
            {businessDetails?.data?.services?.length > 0 ? (
              <Box className="pd-services-section">
                <Typography className="pd-services-heading" sx={{ fontSize: "15px", fontWeight: "600" }}>
                  Services
                </Typography>
                <Grid container columnSpacing={1} sx={{ marginBottom: "10px" }}>
                  {businessDetails?.data?.services?.map((item) => (
                    <Grid item xs={6} md={4} key={item.id}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "baseline",
                        }}
                      >
                        <Box
                          sx={{
                            background: "#14A800",
                            width: "8px",
                            height: "8px",
                            paddingRight: "7px",
                            borderRadius: "20px",
                            marginTop: "8px",
                          }}
                        ></Box>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: "400",
                            wordBreak: "break-word",
                            marginLeft: "8px",
                          }}
                        >
                          {item.name}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
                <hr />
              </Box>
            ) : null}

            <div
              className="pd-social-row"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "1rem",
                margin: "6px 0px",
                flexWrap: "wrap",
              }}
            >
              {businessDetails?.data?.mobile_number &&
                businessDetails?.data?.mobile_number.length > 0 ? (
                <div className="social-media" onClick={handleCalls} style={{ position: 'relative' }}>
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    href={`tel:+91-${businessDetails?.data?.mobile_number}`}
                  >
                    <img
                      src={phonecall}
                      alt="not found"
                      width="35px"
                      height="35px"
                    />
                    {callCounts?.total_calls > 1 && (
                      <span style={{
                        position: 'absolute',
                        top: '-8px',
                        right: '-8px',
                        backgroundColor: '#b43636ff',
                        color: 'white',
                        fontSize: '10px',
                        fontWeight: '600',
                        borderRadius: '10px',
                        padding: '2px 5px',
                        minWidth: '16px',
                        textAlign: 'center',
                        lineHeight: '12px'
                      }}>
                        {callCounts?.total_calls > 999
                          ? `${(callCounts?.total_calls / 1000).toFixed(1)}K`
                          : callCounts?.total_calls}
                      </span>
                    )}
                  </a>
                </div>
              ) : null}
              {businessDetails?.data?.google_location_link &&
                businessDetails?.data?.google_location_link?.length > 0 ? (
                <div className="social-media">
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    href={businessDetails?.data?.google_location_link}
                  >
                    <img src={google} width="35px" height="35px" alt="not found" />
                  </a>
                </div>
              ) : null}
              {businessDetails?.data?.whatsapp_number &&
                businessDetails?.data?.whatsapp_number.length > 0 ? (
                <div className="social-media">
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    href={`https://wa.me/91${businessDetails?.data?.whatsapp_number}?text= Hi, I reached through Master Click`}
                  >
                    <img
                      src={whatsapp}
                      alt="not found"
                      width="35px"
                      height="35px"
                    />
                  </a>
                </div>
              ) : null}
              {businessDetails?.data?.facebook ? (
                <div className="social-media">
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    href={businessDetails?.data?.facebook}
                  >
                    <img
                      src={facebook}
                      alt="not found"
                      width="35px"
                      height="35px"
                    />
                  </a>
                </div>
              ) : null}
              {businessDetails?.data?.instagram ? (
                <div className="social-media">
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    href={businessDetails?.data?.instagram}
                  >
                    <img
                      src={instagram}
                      alt="not found"
                      width="35px"
                      height="35px"
                    />
                  </a>
                </div>
              ) : null}

              {businessDetails?.data?.google_review_link ? (
                <div className="social-media">
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    href={businessDetails?.data?.google_review_link}
                  >
                    <img
                      src={google_review}
                      alt="not found"
                      width="35px"
                      height="35px"
                    />
                  </a>
                </div>
              ) : null}

              {businessDetails?.data?.youtube ? (
                <div className="social-media">
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    href={businessDetails?.data?.youtube}
                  >
                    <img src={Youtube} alt="not found" width="35px" height="35px" />
                  </a>
                </div>
              ) : null}

              {businessDetails?.data?.website ? (
                <div className="social-media">
                  <a
                    style={{
                      color: "white",
                      textDecoration: "none",
                      display: "flex",
                    }}
                    href={businessDetails?.data?.website}
                  >
                    <img src={web} width="35px" height="35px" alt="not found" />
                  </a>
                </div>
              ) : null}
            </div>

            <div
              style={{
                width: "100%",
                height: "0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "0px",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  height: "0px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                {/* <p style={{ fontWeight: "500", margin: 0, fontSize: "16px" }}>
              Your Review
            </p>
            <Rating
              name="simple-controlled"
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
              size="small"
              readOnly={!ratingChange}
            /> */}

                {/* {ratingChange ? (
              <Button
                variant="contained"
                style={{
                  backgroundColor: theme.palette.secondary.main,
                  marginTop: "1rem",
                  textTransform: "none",
                }}
                className="pro-btn"
                onClick={handleRating}
              >
                {"Submit"}
              </Button>
            ) : (
              <Button
                variant="contained"
                style={{
                  backgroundColor: theme.palette.secondary.main,
                  marginTop: "1rem",
                  textTransform: "none",
                }}
                className="pro-btn"
                onClick={() => setRatingChange(true)}
              >
                Edit
              </Button>
            )} */}
              </div>
              <div style={{ height: "0px" }}>
                {/* <p style={{ fontWeight: "500", margin: 0, fontSize: "15px" }}>
              {businessDetails?.data?.average_rating &&
                businessDetails?.data?.average_rating.toFixed(1)}{" "}
              {businessDetails?.data?.no_of_ratings
                ? `(${businessDetails?.data?.no_of_ratings} reviews)`
                : "0 reviews"}
            </p> */}
                {/* <Rating
              name="read-only"
              value={
                businessDetails?.data?.average_rating
                  ? businessDetails?.data?.average_rating
                  : 0
              }
              size="small"
              precision={0.1}
              readOnly={true}
            /> */}

              </div>

            </div>
          </div>
        </div>

        </div>
      </div>

      {miniCarouselImages.length > 0 && (
        <div className="pd-mini-carousel-wrap">
          <div className="pd-mini-carousel-track">
            {miniCarouselImages.map((item, idx) => (
              <div className="pd-mini-thumb" key={`${item.id}-${idx}`}>
                <img src={item.catalogue_image} alt="" />
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="product-catalog-section">
        {businessDetails?.data?.catalogue_images?.length > 0 ? (
            <div
              style={{
                width: "100%",
                marginBottom: "40px",
                background: "transparent",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "0px 15px",
                  marginBottom: "8px",
                  background: "transparent",
                }}
              >
                <div>
                  <h3 style={{ margin: 0 }}>Catalogues</h3>
                  <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginTop: "8px" }}>
                    <button
                      type="button"
                      onClick={() => {
                        setSelectedCatalogueCategory("");
                        setSelectedIndex(0);
                      }}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "20px",
                        border: selectedCatalogueCategory === "" ? "2px solid #2182B1" : "1px solid #ccc",
                        background: selectedCatalogueCategory === "" ? "#2182B1" : "#fff",
                        color: selectedCatalogueCategory === "" ? "#fff" : "#333",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 600,
                      }}
                    >
                      All
                    </button>
                    {catalogueCategories.map((category) => (
                      <button
                        type="button"
                        key={category.id}
                        onClick={() => {
                          setSelectedCatalogueCategory(String(category.id));
                          setSelectedIndex(0);
                        }}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "20px",
                          border:
                            String(selectedCatalogueCategory) === String(category.id)
                              ? "2px solid #2182B1"
                              : "1px solid #ccc",
                          background:
                            String(selectedCatalogueCategory) === String(category.id)
                              ? "#2182B1"
                              : "#fff",
                          color:
                            String(selectedCatalogueCategory) === String(category.id)
                              ? "#fff"
                              : "#333",
                          cursor: "pointer",
                          fontSize: "13px",
                          fontWeight: 600,
                        }}
                      >
                        {category.name}
                      </button>
                    ))}
                  </div>
                </div>
                <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
                  {/* Four-column grid layout button */}
                  <div
                    onClick={() => setLayoutMode("fourCol")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      opacity: layoutMode === "fourCol" ? 1 : 0.55,
                      transition: "opacity 0.2s ease, transform 0.1s ease",
                      transform: layoutMode === "fourCol" ? "scale(1.05)" : "scale(1)",
                    }}
                  >
                    <div
                      style={{
                        width: "28px",
                        height: "44px",
                        border: `2px solid ${layoutMode === "fourCol" ? "#555" : "#999"}`,
                        borderRadius: "5px",
                        padding: "3px",
                        display: "flex",
                        flexDirection: "column",
                        background: layoutMode === "fourCol" ? "#e8e8e8" : "#f4f4f4",
                        boxShadow: layoutMode === "fourCol" ? "0 2px 6px rgba(0,0,0,0.18)" : "none",
                      }}
                    >
                      <div style={{ width: "8px", height: "1.5px", backgroundColor: layoutMode === "fourCol" ? "#444" : "#888", margin: "0 auto 3px auto", borderRadius: "1px" }} />
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gridTemplateRows: "1fr 1fr 1fr 1fr", gap: "1.5px", flexGrow: 1 }}>
                        {[...Array(8)].map((_, i) => (
                          <div key={i} style={{ backgroundColor: layoutMode === "fourCol" ? "#555" : "#aaa", borderRadius: "1px" }} />
                        ))}
                      </div>
                    </div>
                    <div style={{ width: "10px", height: "10px", borderRadius: "50%", border: `1.5px solid ${layoutMode === "fourCol" ? "#555" : "#999"}`, marginTop: "4px", display: "flex", alignItems: "center", justifyContent: "center", background: "#f4f4f4" }}>
                      {layoutMode === "fourCol" && <div style={{ width: "5px", height: "5px", borderRadius: "50%", backgroundColor: "#444" }} />}
                    </div>
                  </div>

                  {/* Two-column grid layout button */}
                  <div
                    onClick={() => setLayoutMode("grid")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      opacity: layoutMode === "grid" ? 1 : 0.55,
                      transition: "opacity 0.2s ease, transform 0.1s ease",
                      transform: layoutMode === "grid" ? "scale(1.05)" : "scale(1)",
                    }}
                  >
                    <div
                      style={{
                        width: "28px",
                        height: "44px",
                        border: `2px solid ${layoutMode === "grid" ? "#555" : "#999"}`,
                        borderRadius: "5px",
                        padding: "3px",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        background: layoutMode === "grid" ? "#e8e8e8" : "#f4f4f4",
                        boxShadow: layoutMode === "grid" ? "0 2px 6px rgba(0,0,0,0.18)" : "none",
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "1.5px",
                          backgroundColor: layoutMode === "grid" ? "#444" : "#888",
                          margin: "0 auto 3px auto",
                          borderRadius: "1px",
                        }}
                      />
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "2.5px",
                          flexGrow: 1,
                        }}
                      >
                        <div style={{ backgroundColor: layoutMode === "grid" ? "#555" : "#aaa", borderRadius: "1px" }} />
                        <div style={{ backgroundColor: layoutMode === "grid" ? "#555" : "#aaa", borderRadius: "1px" }} />
                        <div style={{ backgroundColor: layoutMode === "grid" ? "#555" : "#aaa", borderRadius: "1px" }} />
                        <div style={{ backgroundColor: layoutMode === "grid" ? "#555" : "#aaa", borderRadius: "1px" }} />
                        <div style={{ backgroundColor: layoutMode === "grid" ? "#555" : "#aaa", borderRadius: "1px" }} />
                        <div style={{ backgroundColor: layoutMode === "grid" ? "#555" : "#aaa", borderRadius: "1px" }} />
                      </div>
                    </div>
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        border: `1.5px solid ${layoutMode === "grid" ? "#555" : "#999"}`,
                        marginTop: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f4f4f4",
                      }}
                    >
                      {layoutMode === "grid" && (
                        <div
                          style={{
                            width: "5px",
                            height: "5px",
                            borderRadius: "50%",
                            backgroundColor: "#444",
                          }}
                        />
                      )}
                    </div>
                  </div>

                  {/* Taller Layout button */}
                  <div
                    onClick={() => setLayoutMode("tall")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                      opacity: layoutMode === "tall" ? 1 : 0.55,
                      transition: "opacity 0.2s ease, transform 0.1s ease",
                      transform: layoutMode === "tall" ? "scale(1.05)" : "scale(1)",
                    }}
                  >
                    <div
                      style={{
                        width: "28px",
                        height: "44px",
                        border: `2px solid ${layoutMode === "tall" ? "#555" : "#999"}`,
                        borderRadius: "5px",
                        padding: "3px",
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        background: layoutMode === "tall" ? "#e8e8e8" : "#f4f4f4",
                        boxShadow: layoutMode === "tall" ? "0 2px 6px rgba(0,0,0,0.18)" : "none",
                      }}
                    >
                      <div
                        style={{
                          width: "8px",
                          height: "1.5px",
                          backgroundColor: layoutMode === "tall" ? "#444" : "#888",
                          margin: "0 auto 3px auto",
                          borderRadius: "1px",
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flexGrow: 1,
                        }}
                      >
                        <div style={{ flexGrow: 1, backgroundColor: layoutMode === "tall" ? "#555" : "#aaa", borderRadius: "1px" }} />
                      </div>
                    </div>
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        border: `1.5px solid ${layoutMode === "tall" ? "#555" : "#999"}`,
                        marginTop: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#f4f4f4",
                      }}
                    >
                      {layoutMode === "tall" && (
                        <div
                          style={{
                            width: "5px",
                            height: "5px",
                            borderRadius: "50%",
                            backgroundColor: "#444",
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <Card sx={{ boxShadow: "3px 1px 7px #00000061", marginTop: "3px", background: appLayoutMode === "grid" ? "linear-gradient(180deg,#F5FFF7 0%,#ECFFF2 100%)" : "linear-gradient(170deg,#010610 0%,#030c22 18%,#050f30 36%,#071a45 56%,#081e54 74%,#0a2462 100%)", border: "1.5px solid rgba(80,160,255,0.22)" }} className={`pd-catalogue-card${layoutMode === "fourCol" ? " catalog-card--fourCol" : ""}`}>
                <CardContent sx={{ paddingTop: "0px", paddingBottom: "10px" }}>
                  <Grid
                    container
                    spacing={2}
                    sx={{ marginTop: "7px" }}
                  >
                    {filteredCatalogueImages.map((item, index) => (
                      <Grid
                        item
                        xs={layoutMode === "fourCol" ? 6 : layoutMode === "grid" ? 12 : layoutMode === "tall" ? 12 : 12}
                        sm={layoutMode === "fourCol" ? 3 : layoutMode === "grid" ? 4 : layoutMode === "tall" ? 3 : 12}
                        md={layoutMode === "fourCol" ? 3 : layoutMode === "grid" ? 3 : layoutMode === "tall" ? 3 : 12}
                        key={item.id}
                        sx={{
                          marginBottom: "8px",
                        }}
                      >
                        <div
                          onClick={() => {
                            setSelectedIndex(index);
                            setOpen(true);
                          }}
                          className={`img-parent${layoutMode === "fourCol" ? " img-parent--fourCol" : layoutMode === "tall" ? " img-parent--tall" : layoutMode === "grid" ? " img-parent--grid" : ""}`}
                          style={{ cursor: "pointer" }}
                        >
                          <Typography
                            className="typo-name"
                          >
                            {item.name}
                          </Typography>
                          <img
                            src={item.catalogue_image}
                            alt=""
                          />
                          <div
                            className="img-child"
                            style={{
                              height: "100%",
                            }}
                          ></div>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                </CardContent>
              </Card>
              <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={slide?.length > 0 ? slide : []}
                index={selectedIndex}
                render={{
                  buttonPrev: slide.length <= 1 ? () => null : undefined,
                  buttonNext: slide.length <= 1 ? () => null : undefined,
                }}
              />
            </div>
        ) : null}
      </div>
    </div>
  );
};

export default memo(ProductDetails);





